/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShareCopyType } from './ShareCopyType';
import {
    ShareCopyTypeFromJSON,
    ShareCopyTypeFromJSONTyped,
    ShareCopyTypeToJSON,
    ShareCopyTypeToJSONTyped,
} from './ShareCopyType';

/**
 * 
 * @export
 * @interface PostGenerateShareCopyBody
 */
export interface PostGenerateShareCopyBody {
    /**
     * 
     * @type {ShareCopyType}
     * @memberof PostGenerateShareCopyBody
     */
    type: ShareCopyType;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    leaderboardName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    leaderboardGameName?: string;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateShareCopyBody
     */
    leaderboardPrizeValue?: number;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    leaderboardCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    tournamentName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    tournamentGameName?: string;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateShareCopyBody
     */
    tournamentPrizePool?: number;
    /**
     * 
     * @type {number}
     * @memberof PostGenerateShareCopyBody
     */
    tournamentEntryFee?: number;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    challengeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    guildName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    hubName?: string;
    /**
     * For STREAK_MILESTONE — the milestone count reached (e.g. 7, 30, 100)
     * @type {number}
     * @memberof PostGenerateShareCopyBody
     */
    streakMilestone?: number;
    /**
     * For STREAK_MILESTONE — the streak config's display name
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    streakConfigName?: string;
    /**
     * For SEASON_TIER_UNLOCKED — the tier just unlocked
     * @type {number}
     * @memberof PostGenerateShareCopyBody
     */
    seasonTierNumber?: number;
    /**
     * For SEASON_TIER_UNLOCKED — display name of the tier (e.g. "Iron Gauntlet")
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    seasonTierName?: string;
    /**
     * For SEASON_TIER_UNLOCKED — name of the season pass
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    seasonPassName?: string;
    /**
     * For CLIP_SHARED — the clip's display title
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    clipTitle?: string;
    /**
     * For CLIP_SHARED — the game the clip is from
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    clipGameName?: string;
    /**
     * For CLIP_SHARED — true if the sharer is the clip owner (first-person tone). Defaults to false (amplification / third-person tone).
     * @type {boolean}
     * @memberof PostGenerateShareCopyBody
     */
    isClipOwner?: boolean;
    /**
     * For CLIP_SHARED — display name of the clip owner. Used to credit the owner in amplification copy when sharer is not the owner.
     * @type {string}
     * @memberof PostGenerateShareCopyBody
     */
    clipOwnerName?: string;
}



/**
 * Check if a given object implements the PostGenerateShareCopyBody interface.
 */
export function instanceOfPostGenerateShareCopyBody(value: object): value is PostGenerateShareCopyBody {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PostGenerateShareCopyBodyFromJSON(json: any): PostGenerateShareCopyBody {
    return PostGenerateShareCopyBodyFromJSONTyped(json, false);
}

export function PostGenerateShareCopyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostGenerateShareCopyBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ShareCopyTypeFromJSON(json['type']),
        'leaderboardName': json['leaderboardName'] == null ? undefined : json['leaderboardName'],
        'leaderboardGameName': json['leaderboardGameName'] == null ? undefined : json['leaderboardGameName'],
        'leaderboardPrizeValue': json['leaderboardPrizeValue'] == null ? undefined : json['leaderboardPrizeValue'],
        'leaderboardCurrency': json['leaderboardCurrency'] == null ? undefined : json['leaderboardCurrency'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
        'tournamentGameName': json['tournamentGameName'] == null ? undefined : json['tournamentGameName'],
        'tournamentPrizePool': json['tournamentPrizePool'] == null ? undefined : json['tournamentPrizePool'],
        'tournamentEntryFee': json['tournamentEntryFee'] == null ? undefined : json['tournamentEntryFee'],
        'challengeName': json['challengeName'] == null ? undefined : json['challengeName'],
        'guildName': json['guildName'] == null ? undefined : json['guildName'],
        'hubName': json['hubName'] == null ? undefined : json['hubName'],
        'streakMilestone': json['streakMilestone'] == null ? undefined : json['streakMilestone'],
        'streakConfigName': json['streakConfigName'] == null ? undefined : json['streakConfigName'],
        'seasonTierNumber': json['seasonTierNumber'] == null ? undefined : json['seasonTierNumber'],
        'seasonTierName': json['seasonTierName'] == null ? undefined : json['seasonTierName'],
        'seasonPassName': json['seasonPassName'] == null ? undefined : json['seasonPassName'],
        'clipTitle': json['clipTitle'] == null ? undefined : json['clipTitle'],
        'clipGameName': json['clipGameName'] == null ? undefined : json['clipGameName'],
        'isClipOwner': json['isClipOwner'] == null ? undefined : json['isClipOwner'],
        'clipOwnerName': json['clipOwnerName'] == null ? undefined : json['clipOwnerName'],
    };
}

export function PostGenerateShareCopyBodyToJSON(json: any): PostGenerateShareCopyBody {
    return PostGenerateShareCopyBodyToJSONTyped(json, false);
}

export function PostGenerateShareCopyBodyToJSONTyped(value?: PostGenerateShareCopyBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ShareCopyTypeToJSON(value['type']),
        'leaderboardName': value['leaderboardName'],
        'leaderboardGameName': value['leaderboardGameName'],
        'leaderboardPrizeValue': value['leaderboardPrizeValue'],
        'leaderboardCurrency': value['leaderboardCurrency'],
        'tournamentName': value['tournamentName'],
        'tournamentGameName': value['tournamentGameName'],
        'tournamentPrizePool': value['tournamentPrizePool'],
        'tournamentEntryFee': value['tournamentEntryFee'],
        'challengeName': value['challengeName'],
        'guildName': value['guildName'],
        'hubName': value['hubName'],
        'streakMilestone': value['streakMilestone'],
        'streakConfigName': value['streakConfigName'],
        'seasonTierNumber': value['seasonTierNumber'],
        'seasonTierName': value['seasonTierName'],
        'seasonPassName': value['seasonPassName'],
        'clipTitle': value['clipTitle'],
        'clipGameName': value['clipGameName'],
        'isClipOwner': value['isClipOwner'],
        'clipOwnerName': value['clipOwnerName'],
    };
}

